import { useNavigate, useParams } from 'react-router-dom';
import { useApp } from '../context';
import { UserMinus, ArrowLeft } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

export default function DeleteContact() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state, deleteContact } = useApp();

  const contact = state.contacts.find((c) => c.id === id);

  if (!contact) {
    return <div className="p-8 text-center text-slate-500">Contact not found</div>;
  }

  const handleDelete = () => {
    if (!id) return;
    deleteContact(id);
    navigate('/', { replace: true });
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-900/40 p-6 backdrop-blur-sm"
      >
        <div className="w-full max-w-sm rounded-[32px] bg-white p-6 shadow-2xl relative overflow-hidden">
          {/* Background decoration */}
          <div className="absolute -top-24 -right-24 size-48 rounded-full bg-red-50 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 size-48 rounded-full bg-[#fa8585]/10 blur-3xl" />

          <div className="relative z-10">
            <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-50 text-red-500">
              <UserMinus size={32} />
            </div>

            <h2 className="mb-2 text-center text-xl font-bold text-slate-900 leading-tight">
              Stop tracking <br />
              <span className="text-[#fa8585]">{contact.name}</span>?
            </h2>

            <p className="mb-8 text-center text-[15px] leading-relaxed text-slate-500 px-2">
              Are you sure you want to stop tracking your relationship with{' '}
              {contact.name.split(' ')[0]}? Their profile and interaction history will be archived.
            </p>

            <div className="flex flex-col gap-3">
              <button
                onClick={handleDelete}
                className="flex w-full items-center justify-center gap-2 rounded-2xl bg-red-500 p-4 font-bold text-white transition-all active:scale-[0.98] shadow-lg shadow-red-500/20"
              >
                <span>Yes, Remove Contact</span>
              </button>
              <button
                onClick={() => navigate(-1)}
                className="flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-100 p-4 font-bold text-slate-700 transition-all hover:bg-slate-200 active:scale-[0.98]"
              >
                <ArrowLeft size={18} />
                <span>Nevermind, Keep Tracking</span>
              </button>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );
}
